document.addEventListener("DOMContentLoaded", () => {
  // ==========================================================
  // === CAPITAL CART DRAWER SCRIPT (FINAL SYNCED VERSION) ===
  // ==========================================================

  // --- Elemen Penting ---
  const cartDrawer = document.getElementById("cartDrawer");
  const cartDrawerOverlay = document.getElementById("cartDrawerOverlay");
  const cartTriggers = document.querySelectorAll(".cart-btn"); // Target spesifik ikon cart di header
  const closeBtn = document.querySelector('[data-action="close-cart-drawer"]');
  const cartBody = cartDrawer ? cartDrawer.querySelector(".cart-drawer__body") : null;
  const cartItemContainer = cartBody ? cartBody.querySelector(".cart-item-container") : null;
  const cartFooter = cartDrawer ? cartDrawer.querySelector(".cart-drawer__footer") : null;
  const cartCountSpans = document.querySelectorAll(".cart-count");
  const recommendationsContainer = cartDrawer
    ? cartDrawer.querySelector("[data-recommendations-container]")
    : null;
  const recommendationNavPrev = cartDrawer
    ? cartDrawer.querySelector('[data-action="prev-recommendation"]')
    : null;
  const recommendationNavNext = cartDrawer
    ? cartDrawer.querySelector('[data-action="next-recommendation"]')
    : null;
  const shopMoneyFormat = window.shopMoneyFormat || "${{amount}}"; // Ambil dari theme.liquid
  const checkoutBtn = cartFooter ? cartFooter.querySelector(".cart-drawer__checkout-btn") : null; // Tombol Checkout

  if (!cartDrawer || !cartBody || !cartItemContainer || !cartFooter) {
    console.warn(
      "Cart Drawer: Essential elements (#cartDrawer, body, item-container, footer) not found."
    );
    return; // Hentikan jika elemen dasar tidak ada
  }

  // --- Fungsi Buka/Tutup ---
  const openCartDrawer = () => {
    console.log("Cart Drawer: openCartDrawer function CALLED!"); // <-- TAMBAHKAN INI
    updateCartDrawer(); // Selalu update saat dibuka
    cartDrawer.classList.add("is-open");
    cartDrawerOverlay.classList.add("is-open");
    document.body.style.overflow = "hidden";
  };

  const closeCartDrawer = () => {
    cartDrawer.classList.remove("is-open");
    cartDrawerOverlay.classList.remove("is-open");
    document.body.style.overflow = "";
  };

  // --- Fungsi Fetch Rekomendasi ---
  const fetchRecommendations = async (productId) => {
    if (!recommendationsContainer) return;
    recommendationsContainer.innerHTML =
      '<p style="font-size: 0.8rem; color: #666;">Loading recommendations...</p>';
    try {
      const response = await fetch(
        `/recommendations/products.json?product_id=${productId}&limit=4&section_id=cart-drawer`
      );
      if (!response.ok) throw new Error("Failed to fetch recommendations");
      const data = await response.json();

      if (data.products && data.products.length > 0) {
        recommendationsContainer.innerHTML = data.products
          .map((product) => {
            const firstVariant = product.variants[0];
            const price = firstVariant.price
              ? formatMoney(firstVariant.price, shopMoneyFormat)
              : "";

            let sizeDropdownHtml = "";
            let needsSizeSelection = false;
            const sizeOption = product.options.find((opt) => opt.name.toLowerCase() === "size");

            if (sizeOption && product.variants.length > 1) {
              needsSizeSelection = true;
              sizeDropdownHtml = `<select class="recommendation-card__size-select" data-product-handle="${product.handle}"><option value="">Select size</option>${sizeOption.values.map((value) => `<option value="${value}">${value}</option>`).join("")}</select>`;
            } else if (product.variants.length === 1 && firstVariant.title !== "Default Title") {
              sizeDropdownHtml = `<select class="recommendation-card__size-select is-disabled" disabled><option value="${firstVariant.title}">${firstVariant.title}</option></select>`;
            } else {
              sizeDropdownHtml = `<select class="recommendation-card__size-select is-disabled" disabled><option value="">One size</option></select>`;
            }

            return `
              <div class="recommendation-card" data-product-json='${JSON.stringify(product)}'>
                <a href="${product.url}"><img class="recommendation-card__image" src="${product.featured_image || "placeholder.jpg"}" alt="${product.title}"></a>
                <a href="${product.url}" class="recommendation-card__title">${product.title}</a>
                <span class="recommendation-card__price">${price}</span>
                <div class="recommendation-card__action">
                  ${sizeDropdownHtml}
                  <form action="/cart/add" method="post" data-ajax-cart-form>
                    <input type="hidden" name="id" value="${needsSizeSelection ? "" : firstVariant.id}">
                    <input type="hidden" name="quantity" value="1">
                    <button type="submit" class="recommendation-add-btn ${needsSizeSelection ? "is-disabled" : ""}" ${needsSizeSelection ? "disabled" : ""}>+</button>
                  </form>
                </div>
              </div>`;
          })
          .join("");
        // [DI-UPGRADE] Panggil update tombol SETELAH browser sempat 'menggambar'
        setTimeout(() => {
          updateRecommendationNavButtons();
        }, 50); // Jeda 50 milidetik (biasanya cukup)
      } else {
        recommendationsContainer.innerHTML =
          '<p style="font-size: 0.8rem; color: #666;">No recommendations available.</p>';
      }
    } catch (error) {
      console.error("Failed to load recommendations:", error);
      recommendationsContainer.innerHTML =
        '<p style="font-size: 0.8rem; color: #666;">Could not load recommendations.</p>';
    }
  };
  // <<< TARUH DI SINI >>>
  // [BARU] Fungsi untuk mengupdate status tombol navigasi slider
  const updateRecommendationNavButtons = () => {
    if (!recommendationsContainer || !recommendationNavPrev || !recommendationNavNext) return;
    const scrollLeft = recommendationsContainer.scrollLeft;
    const maxScrollLeft =
      recommendationsContainer.scrollWidth - recommendationsContainer.clientWidth;
    recommendationNavPrev.disabled = scrollLeft <= 0;
    recommendationNavNext.disabled = scrollLeft >= maxScrollLeft - 4;
  };

  // --- Fungsi Utama: Mengisi Drawer dengan Produk ---
  const updateCartDrawer = async () => {
    const recommendationsSection = cartBody.querySelector(".cart-recommendations");
    if (recommendationsSection) recommendationsSection.style.display = "none"; // Sembunyikan rekomendasi saat loading

    // Tampilkan state loading awal (opsional)
    cartItemContainer.innerHTML = "<p>Please wait...</p>";

    try {
      const res = await fetch("/cart.js");
      const cart = await res.json();

      // Update angka di header (global)
      cartCountSpans.forEach((span) => {
        span.textContent = cart.item_count;
      });

      // Update angka dan teks di judul drawer
      const drawerTitleH2 = cartDrawer.querySelector(".cart-drawer__title");
      if (drawerTitleH2) {
        const countSpan = drawerTitleH2.querySelector(".cart-drawer__item-count");
        const wrapperSpan = drawerTitleH2.querySelector(".cart-drawer__item-count-wrapper");
        if (countSpan && wrapperSpan) {
          countSpan.textContent = cart.item_count;
          const itemText = cart.item_count === 1 ? "item" : "items";
          wrapperSpan.textContent = `(${cart.item_count} ${itemText})`;
        }
      }

      // Handle keranjang kosong
      if (cart.item_count === 0) {
        if (cartItemContainer) {
          // Ambil URL login dari data attribute drawer
          const loginUrl = cartDrawer.dataset.loginUrl || "/account/login"; // Fallback

          cartItemContainer.innerHTML = `
          <div class="cart-empty-state">
          <h4 class="cart-empty-heading">MISSING ITEMS IN YOUR CART?</h4>
            <p class="cart-empty-subtext">
              <a href="${loginUrl}">Sign in</a> to see items you added before.
            </p>
           <pre class="cart-empty-ascii"></pre>
          </div>
        `;
        }
        if (cartFooter) cartFooter.style.display = "none";
        if (recommendationsSection) recommendationsSection.style.display = "none";
        return; // Hentikan fungsi jika kosong
      }

      // Handle keranjang berisi
      cartFooter.style.display = "block"; // Tampilkan footer
      cartItemContainer.innerHTML = cart.items
        .map((item) => {
          const finalLinePrice = item.final_line_price
            ? formatMoney(item.final_line_price, shopMoneyFormat)
            : "";
          return `
            <div class="cart-item" data-line-key="${item.key}">
              <a href="${item.url}" class="cart-item__image-link"><img class="cart-item__image" src="${item.image || "placeholder.jpg"}" alt="${item.title}"></a>
              <div class="cart-item__details">
                <span class="cart-item__vendor">${item.vendor}</span>
                <a href="${item.url}" class="cart-item__title">${item.product_title}</a>
                <span class="cart-item__variant">${item.variant_title || ""}</span>
                <div class="cart-item__quantity">
                  <button data-action="decrease-qty" data-key="${item.key}">-</button>
                  <span>${item.quantity}</span>
                  <button data-action="increase-qty" data-key="${item.key}">+</button>
                </div>
              </div>
              <div class="cart-item__meta">
                <span class="cart-item__price">${finalLinePrice}</span>
                <a class="cart-item__remove" data-action="remove-item" data-key="${item.key}">Remove</a>
              </div>
            </div>`;
        })
        .join("");

      // [PERBAIKAN CHECKOUT BUTTON] Update subtotal dan tombol checkout di footer
      const subtotalValueElement = cartFooter.querySelector(".cart-drawer__subtotal-value"); // Pastikan class ini ada di HTML
      const checkoutPriceElement = cartFooter.querySelector(".cart-drawer__checkout-price"); // Pastikan class ini ada di HTML

      if (subtotalValueElement) {
        subtotalValueElement.textContent = cart.total_price
          ? formatMoney(cart.total_price, shopMoneyFormat)
          : "";
      }
      if (checkoutBtn) {
        // Ambil URL dari data attribute di footer
        const checkoutUrl = cartFooter.dataset.checkoutUrl || "/checkout"; // Fallback
        checkoutBtn.href = checkoutUrl; // Set href tombolnya
        if (checkoutPriceElement) {
          checkoutPriceElement.textContent = cart.total_price
            ? formatMoney(cart.total_price, shopMoneyFormat)
            : "";
        }
      } else {
        console.warn("Checkout button not found in cart drawer footer.");
      }

      // Tampilkan & fetch rekomendasi JIKA ada item
      if (cart.items.length > 0 && recommendationsSection) {
        recommendationsSection.style.display = "block";
        fetchRecommendations(cart.items[0].product_id);
      }
    } catch (error) {
      console.error("Failed to update cart drawer:", error);
      cartItemContainer.innerHTML = "<p>Error loading cart. Please try again.</p>";
    }
  };

  // --- Event Listeners ---
  cartTriggers.forEach((trigger) => {
    if (trigger)
      trigger.addEventListener("click", (e) => {
        console.log("Cart Drawer: Cart trigger CLICKED by element:", e.target); // <-- TAMBAHKAN INI
        e.preventDefault();
        openCartDrawer();
      });
  });
  if (closeBtn) closeBtn.addEventListener("click", closeCartDrawer);
  if (cartDrawerOverlay) cartDrawerOverlay.addEventListener("click", closeCartDrawer);
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && cartDrawer && cartDrawer.classList.contains("is-open"))
      closeCartDrawer();
  });

  document.addEventListener("cart:updated", () => {
    updateCartDrawer(); // Update drawer saat ada sinyal
  });

  // Event listener untuk Aksi di dalam cartBody (delegated)
  if (cartBody) {
    // Listener untuk Klik (Quantity, Remove)
    cartBody.addEventListener("click", async (e) => {
      const target = e.target;
      const qtyButton = target.closest(
        '[data-action="decrease-qty"], [data-action="increase-qty"]'
      );
      const removeLink = target.closest('[data-action="remove-item"]');

      let itemKey;
      let newQuantity;

      if (qtyButton) {
        itemKey = qtyButton.dataset.key;
        const isIncrease = qtyButton.dataset.action === "increase-qty";
        const quantityElement = isIncrease
          ? qtyButton.previousElementSibling
          : qtyButton.nextElementSibling;
        const currentQty = parseInt(quantityElement.textContent);
        newQuantity = isIncrease ? currentQty + 1 : currentQty - 1;
      } else if (removeLink) {
        itemKey = removeLink.dataset.key;
        newQuantity = 0; // Removing item
      } else {
        return; // Abaikan klik lain di dalam cart body
      }

      if (!itemKey || newQuantity < 0) return; // Jangan proses jika key tidak ada atau qty negatif

      const cartItemElement = target.closest(".cart-item");
      if (cartItemElement) cartItemElement.style.opacity = "0.5"; // Loading state

      try {
        const response = await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: itemKey, quantity: newQuantity }),
        });
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.description || "Failed to update quantity");
        }
        document.dispatchEvent(new CustomEvent("cart:updated")); // Kirim sinyal update
      } catch (error) {
        console.error("Failed to update cart quantity:", error);
        if (cartItemElement) cartItemElement.style.opacity = "1"; // Kembalikan opacity
        alert(`Error: ${error.message}`);
      }
      // [BARU] Event listener untuk tombol navigasi slider rekomendasi
      if (recommendationNavPrev && recommendationNavNext && recommendationsContainer) {
        recommendationNavPrev.addEventListener("click", () => {
          // Scroll ke kiri sejauh lebar satu kartu + gap
          const scrollAmount =
            (recommendationsContainer.querySelector(".recommendation-card")?.offsetWidth || 150) +
            16; // 16px estimasi gap
          recommendationsContainer.scrollBy({ left: -scrollAmount, behavior: "smooth" });
          // Update status tombol setelah scroll (dengan sedikit delay)
          setTimeout(updateRecommendationNavButtons, 400);
        });

        recommendationNavNext.addEventListener("click", () => {
          // Scroll ke kanan sejauh lebar satu kartu + gap
          const scrollAmount =
            (recommendationsContainer.querySelector(".recommendation-card")?.offsetWidth || 150) +
            16;
          recommendationsContainer.scrollBy({ left: scrollAmount, behavior: "smooth" });
          // Update status tombol setelah scroll (dengan sedikit delay)
          setTimeout(updateRecommendationNavButtons, 400);
        });

        // Update status tombol saat user scroll manual (jika perlu)
        recommendationsContainer.addEventListener("scroll", updateRecommendationNavButtons);
      }
    });

    // Listener untuk Perubahan Dropdown Rekomendasi
    cartBody.addEventListener("change", (e) => {
      if (e.target.matches(".recommendation-card__size-select")) {
        const selectElement = e.target;
        const selectedSize = selectElement.value;
        const card = selectElement.closest(".recommendation-card");
        const addButton = card.querySelector(".recommendation-add-btn");
        const hiddenIdInput = card.querySelector('input[name="id"]');
        const productData = JSON.parse(card.dataset.productJson);

        if (selectedSize) {
          const foundVariant = productData.variants.find((variant) =>
            variant.options.includes(selectedSize)
          ); // Cari varian yg punya size itu

          if (foundVariant) {
            hiddenIdInput.value = foundVariant.id;
            addButton.disabled = false;
            addButton.classList.remove("is-disabled");
          } else {
            hiddenIdInput.value = "";
            addButton.disabled = true;
            addButton.classList.add("is-disabled");
          }
        } else {
          hiddenIdInput.value = "";
          addButton.disabled = true;
          addButton.classList.add("is-disabled");
        }
      }
    });

    // Listener untuk Submit Form Rekomendasi
    cartBody.addEventListener("submit", async (e) => {
      if (e.target.matches(".recommendation-card__action [data-ajax-cart-form]")) {
        // Lebih spesifik
        e.preventDefault();
        const form = e.target;
        const submitButton = form.querySelector('button[type="submit"]');
        const originalButtonText = submitButton.textContent;
        const variantId = form.querySelector('input[name="id"]').value;

        if (!variantId) {
          // Jangan submit jika size belum dipilih
          alert("Please select a size first.");
          return;
        }

        submitButton.disabled = true;
        submitButton.textContent = "...";

        const quantity = form.querySelector('input[name="quantity"]').value;
        const body = JSON.stringify({ items: [{ id: variantId, quantity: quantity }] });

        try {
          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: body,
          });
          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.description || "Something went wrong");
          }

          document.dispatchEvent(new CustomEvent("cart:updated")); // Kirim sinyal update

          setTimeout(() => {
            // Reset tombol
            submitButton.textContent = originalButtonText;
            submitButton.disabled = false;
          }, 800);
        } catch (error) {
          console.error("AJAX Cart Error (Recommendation):", error);
          submitButton.textContent = "X";
          setTimeout(() => {
            submitButton.textContent = originalButtonText;
            submitButton.disabled = false;
          }, 2000);
          alert(`Error: ${error.message}`);
        }
      }
    });
  } else {
    console.warn("Cart Drawer: cartBody element not found for event delegation.");
  }
}); // Menutup DOMContentLoaded

// --- Helper function formatMoney (DI LUAR DOMContentLoaded) ---
function formatMoney(cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  let value = "";
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || "${{amount}}"; // Default aman jika format tidak ada
  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    let parts = number.split(".");
    let dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
    let cents = parts[1] ? decimal + parts[1] : "";
    return dollars + cents;
  }
  const match = formatString.match(placeholderRegex);
  // GANTI BAGIAN AKHIR FUNGSI formatMoney MENJADI SEPERTI INI:
  if (match && match[1]) {
    switch (match[1]) {
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0, ",", ".");
        break;
      default:
        value = formatWithDelimiters(cents, 2, ",", ".");
        break;
    }
    // Langsung return format string yang sudah diisi angka, tanpa menghapus simbol
    return formatString.replace(placeholderRegex, value);
  } else if (formatString.includes("amount")) {
    // Fallback jika regex gagal tapi 'amount' ada
    return formatString.replace("{{amount}}", formatWithDelimiters(cents, 2, ",", "."));
  }
  // Fallback paling akhir
  console.warn("Using default money format due to unrecognized format:", formatString);
  // Default fallback mungkin perlu menyertakan simbol secara manual jika formatString aneh
  const defaultFormattedAmount = formatWithDelimiters(cents, 2, ",", ".");
  // Coba tebak simbol dari format string umum atau setting toko (jika bisa diakses)
  // Contoh sederhana:
  if (formatString.includes("Rp")) return "Rp " + defaultFormattedAmount;
  if (formatString.includes("$")) return "$" + defaultFormattedAmount;
  return defaultFormattedAmount; // Fallback tanpa simbol jika tidak dikenali
}
